import DetailList from '@/components/DetailList/detail-list.example';

export default DetailList;
